import { gql } from "@apollo/client";

export const GET_PRESIGNED_URL = gql`
  query getPresignedUrl($input: preSignedUrlInput!) {
    getUploadPresignedUrl(input: $input) {
      preSignedUrl
      region
    }
  }
`;

export const CHECK_UNIQUE_NAME_EXIST_IN_WORKSHOP = gql`
query getExistingWorkShopSession($searchInput: String = "%") {
  allWorkshopSessions(
    filter: {deletedAt: {isNull: true}, seTitle: {likeInsensitive: $searchInput}, seType: {equalTo: UPLOADED}}
  ) {
    nodes {
      seId
      seTitle
      seType
      seUrl
    }
  }
}
`;

export const ALL_SUBJECTS = gql`
  query AllSubjects($sjName: String! = "%") {
    allSubjects(
      filter: {
        and: [
          { deletedAt: { isNull: true } }
          {
            or: [
              { sjName: { likeInsensitive: $sjName } }
              { sjOriginalName: { likeInsensitive: $sjName } }
            ]
          }
        ]
      }
    ) {
      nodes {
        sjName
        sjOriginalName
        sjId
      }
      totalCount
    }
  }
`;

export const INSERT_SUBJECTS = gql`
  mutation InsertSubjects($sjName: String!) {
    insertSubjects(sjName: $sjName)
  }
`;
